import { AdaptsObjectToToken, AdaptsTokenToObject, PaywallToken, TokenType } from '@d24/demarked'
import { ModuleDriver } from '../_contracts'
import { PaywallModule } from '../Paywall/Paywall.contracts'
import { getModuleBase } from '../_helpers/adapter'

/**
 * @author Adrian Gajos <adrian.gajos@movecloser.pl>
 */
export class PaywallAdapter implements AdaptsObjectToToken<ModuleDriver.Paywall, PaywallModule, PaywallToken>,
  AdaptsTokenToObject<PaywallToken, PaywallModule> {
  /**
   * @inheritDoc
   */
  public objectToToken (): PaywallToken {
    return {
      content: '#PAYWALL',
      raw: '#PAYWALL',
      type: TokenType.Paywall
    }
  }

  /**
   * @inheritDoc
   */
  public tokenToObject (): PaywallModule {
    return {
      ...getModuleBase(),
      content: {},
      driver: ModuleDriver.Paywall
    }
  }
}
